const func = {
	isNullOrEmpty: function(value) {
		//是否为空
		return (value === null || value === '' || value === undefined || value === 'undefined') ? true : false;
	},
	platform: function() {
		let system = {
			win: false,
			mac: false,
			xll: false,
			ipad: false
		}
		let p = window.navigator.platform
		system.win = p.indexOf("Win") == 0
		system.mac = p.indexOf("Mac") == 0
		system.x11 = (p == "X11") || (p.indexOf("Linux") == 0)
		system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false

		if (system.win || system.mac || system.xll || system.ipad) {
			return 'pc'
		}

		let ua = navigator.userAgent.toLowerCase()

		if (ua.match(/MicroMessenger/i) == "micromessenger") {
			return 'wechat'
		}

		return 'h5'
	},
	/**
	 * 格式化测试人数
	 */
	formatTestNum: function(num) {
		let iTestNum;
		let current = parseInt(num)
		if (current) {
			if (current <= 10000) {
				iTestNum = current
			} else {
				iTestNum = (current / 10000).toFixed(2) + "万"
			}
		} else {
			iTestNum = 0;
		}
		return iTestNum
	},

	getParameter(url, key) {
		let urlObj = new URL(url);
		let hash = urlObj.hash.substr(1);
		let query = urlObj.search.substr(1);
		let origin = urlObj.origin;
		let newUrlObj = new URL(origin + hash + '&' + query);
		let value = newUrlObj.searchParams.get(key);
		if (!value) {
			value = 'null'
		}
		return value
	},

	/**
	 * 通过域名判定是否是框架户
	 * @returns bool true: 是 false: 否
	 */
	checkChannel() {
		let channelOne = 'nbyunya.cn';
		let channelTwo = 'zycp.nbdeyue.cn';
		let urlStr = window.location.href;
		let value = 0;
		if (urlStr.indexOf(channelOne) > -1) {
			value = 1
		}

		if (urlStr.indexOf(channelTwo) > -1) {
			value = 2
		}
		console.log(value)
		return value
	},
	/*
	 *	本地历史记录
	 */
	history(data, tid) {
		if (!data) return
		let arr = localStorage.getItem('history')
		if (arr) {
			arr = JSON.parse(arr);
		} else {
			arr = [];
		}

		let isFlag = false;

		for (let item of arr) {
			if (item.pid == data.psid) {
				isFlag = true;
				item.tid = tid;
				break
			}
		}
		if (!isFlag) {
			arr.push({
				pid: data.psid,
				tid: tid,
				title: data.productscale.title
			});
		}
		localStorage.setItem('history', JSON.stringify(arr));
	}
}

export default func
